<template>
    <div v-if="!loading">
        <v-row class="pa-10 pb-0">
            <v-text-field outlined dense label="Search" @input="searchTicket($event)"></v-text-field> &nbsp;
            <v-btn color="primary" elevation="0" class="ml-3" @click="downloadTickets"> Export All Tickets </v-btn>
        </v-row>
        <v-col cols="12" class="ma-0 pa-0">
            <base-divider color="primary" space="3" max-width="100%" />
        </v-col>
        <v-container>
            <v-row class="pa-0 pb-15">
                <v-col cols="2" class="pa-0">
                    <v-select
                        v-model="selectedYear"
                        class="pr-3 pl-3"
                        :items="years"
                        hide-details
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                        label="Year"
                    ></v-select>
                    <v-navigation-drawer permanent>
                        <v-list dense nav>
                            <v-divider></v-divider>
                            <template v-for="(item, i) in months">
                                <v-list-item
                                    :key="item.text"
                                    link
                                    class="mb-0"
                                    :disabled="
                                        !tickets[selectedYear].items[item.value] ||
                                        !tickets[selectedYear].items[item.value].items
                                    "
                                    @click="selectMonth(item.value)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title
                                            :style="selectedMonth === item.value ? 'color: #db5120' : ''"
                                            >{{ item.text }}</v-list-item-title
                                        >
                                    </v-list-item-content>
                                    <v-spacer></v-spacer>
                                    <v-chip
                                        :color="selectedMonth === item.value ? '#db5120' : ''"
                                        :class="selectedMonth === item.value ? 'white--text' : ''"
                                        label
                                        :disabled="
                                            !tickets[selectedYear].items[item.value] ||
                                            !tickets[selectedYear].items[item.value].items
                                        "
                                        >{{
                                            tickets[selectedYear].items[item.value] &&
                                            tickets[selectedYear].items[item.value].items
                                                ? tickets[selectedYear].items[item.value].items.length
                                                : 0
                                        }}</v-chip
                                    >
                                </v-list-item>
                                <v-divider :key="i" class="ma-0 pa-0"></v-divider>
                            </template>
                        </v-list>
                    </v-navigation-drawer>
                </v-col>
                <v-col cols="10" class="pa-0">
                    <v-data-table
                        :items="tickets[selectedYear].items[selectedMonth].items || []"
                        :headers="headers"
                        :loading="loading"
                        :search="search"
                    >
                        <template v-slot:item.ticket="{ item }"
                            ><a style="color: #db5120; text-decoration: underline" @click="openTicket(item.ticket)">{{
                                item.ticket
                            }}</a></template
                        >
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <v-navigation-drawer
            v-model="viewTicket"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            persistent
            :width="$vuetify.breakpoint.smAndDown ? `100%` : `60%`"
            right
            fixed
            temporary
            color="grey lighten-4"
        >
            <v-card flat max-height="100%" color="grey lighten-4">
                <v-toolbar dark>
                    <v-toolbar-title class="text-overline">Viewing {{ selectedTicket }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="viewTicket = false">
                        <v-icon>{{ mdiClose }}</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <hf-ticket :ticket-id="selectedTicket" :is-open="viewTicket"></hf-ticket>
                </v-card-text>
            </v-card>
        </v-navigation-drawer>
    </div>
</template>

<script>
import { fetchHfCases } from '@/api'
import HfTicket from './hf_ticket.vue'
import { mdiClose } from '@mdi/js'
import { cloneDeep } from 'lodash'
import { downloadJsonAsExcel } from '@/utils/excel'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Dashboard` },
    name: `CdfwHappyfox`,
    components: { HfTicket },
    data() {
        return {
            selectedYear: null,
            years: [],
            search: ``,
            mdiClose,
            selectedTicket: '',
            viewTicket: false,
            loading: true,
            tickets: [],
            allTickets: [],
            headers: [
                {
                    text: 'Subject',
                    align: 'start',
                    sortable: true,
                    value: 'subject'
                },
                {
                    text: 'Assigned Agent',
                    align: 'start',
                    sortable: true,
                    value: 'assigned_to'
                },
                {
                    text: 'Status',
                    align: 'start',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: 'Created At',
                    align: 'start',
                    sortable: true,
                    value: 'createdat'
                },
                {
                    text: 'Last Agent Reply At',
                    align: 'start',
                    sortable: true,
                    value: 'lastagentreplyat'
                },
                {
                    text: 'First Response Time (minutes)',
                    align: 'start',
                    sortable: true,
                    value: 'first_reponse_time'
                },

                {
                    text: 'Closed At',
                    align: 'start',
                    sortable: true,
                    value: 'closedat'
                },
                {
                    text: 'Closed By',
                    align: 'start',
                    sortable: true,
                    value: 'closedby'
                },
                {
                    text: 'Number of Agents Replies',
                    align: 'start',
                    sortable: true,
                    value: 'agentreplynumber'
                },
                {
                    text: 'Contact Name',
                    align: 'start',
                    sortable: true,
                    value: 'create_by'
                },
                {
                    text: 'Contact Email',
                    align: 'start',
                    sortable: true,
                    value: 'create_by_email'
                },
                {
                    text: 'Ticket',
                    align: 'start',
                    sortable: true,
                    value: 'ticket'
                }
            ],
            selectedMonth: 0,
            months: [
                {
                    text: 'January',
                    value: 0
                },
                {
                    text: 'February',
                    value: 1
                },
                {
                    text: 'March',
                    value: 2
                },
                {
                    text: 'April',
                    value: 3
                },
                {
                    text: 'May',
                    value: 4
                },
                {
                    text: 'June',
                    value: 5
                },
                {
                    text: 'July',
                    value: 6
                },
                {
                    text: 'August',
                    value: 7
                },
                {
                    text: 'September',
                    value: 8
                },
                {
                    text: 'October',
                    value: 9
                },
                {
                    text: 'November',
                    value: 10
                },
                {
                    text: 'December',
                    value: 11
                }
            ]
        }
    },
    computed: {},
    watch: {
        viewTicket: {
            handler(v) {
                if (!v) {
                    this.selectedTicket = null
                }
            }
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        searchTicket(ticket) {
            if (ticket === '') this.search = ''
            const found = this.allTickets.find((e) => e.ticket === ticket)
            if (found) {
                this.selectedMonth = found.month
                this.search = ticket
            }
        },
        downloadTickets() {
            downloadJsonAsExcel(
                `hftickets`,
                `HFTickets`,
                this.allTickets.map((e) => ({
                    Ticket: e.ticket,
                    Subject: e.subject,
                    'Origin Message': e.firstmessage,
                    'Assigned Agent Name': e.assigned_to,
                    'Ticket Status': e.status,
                    'Created At': e.createdat,
                    'Last Agent Reply At': e.lastagentreplyat,
                    'First Response Time (Minutes)': e.first_reponse_time,
                    'Closed At': e.closedat,
                    'Closed By': e.closedby,
                    'Number of Agent Replies': e.agentreplynumber,
                    'Contact Name': e.create_by,
                    'Contact Email': e.create_by_email
                }))
            )
        },

        selectMonth(month) {
            this.search = ''
            this.selectedMonth = month
        },
        groupByMonth(items) {
            const grouped = items.reduce((acc, curr) => {
                const month = curr.month
                let group = acc.find((item) => item.month === month)

                if (!group) {
                    group = {
                        month: month,
                        items: []
                    }
                    acc.push(group)
                }
                group.items.push(curr)

                return acc
            }, [])

            return grouped
        },
        groupByYear(items) {
            const grouped = items.reduce((acc, curr) => {
                const year = curr.year
                let group = acc.find((item) => item.year === year)

                if (!group) {
                    group = {
                        year: year,
                        items: []
                    }
                    acc.push(group)
                }
                group.items.push(curr)

                return acc
            }, [])

            return grouped
        },
        openTicket(ticketId) {
            this.selectedTicket = ticketId
            this.viewTicket = true
        },
        async fetchData() {
            this.$emit('loading', true)
            this.loading = true
            const results = (await fetchHfCases({})).data
            const mapped = results.map((item) => ({
                ...item,
                createdat: item.createdat && item.createdat.value ? new Date(item.createdat.value).toDateString() : '',
                closedat: item.closedat && item.closedat.value ? new Date(item.closedat.value).toDateString() : '',
                firstreplydate:
                    item.firstreplydate && item.firstreplydate.value
                        ? new Date(item.firstreplydate.value).toDateString()
                        : '',
                lastagentreplyat:
                    item.lastagentreplyat && item.lastagentreplyat.value
                        ? new Date(item.lastagentreplyat.value).toDateString()
                        : '',
                month: item.createdat && item.createdat.value ? new Date(item.createdat.value).getMonth() : '',
                year: item.createdat && item.createdat.value ? new Date(item.createdat.value).getFullYear() : ''
            }))
            this.allTickets = cloneDeep(mapped)

            // group by year then month
            const byYear = this.groupByYear(mapped)
                .sort((a, b) => a.year - b.year)
                .map((e, i) => ({
                    ...e,
                    index: i
                }))

            this.years = byYear.map((e) => ({ text: e.year, value: e.index })).sort((a, b) => a.index - b.index)
            for (let i = 0; i < byYear.length; i++) {
                byYear[i].items = this.groupByMonth(byYear[i].items).sort((a, b) => a.month - b.month)
            }
            this.tickets = byYear

            // select current year
            const currentYear = new Date().getFullYear()
            const foundYear = this.years.find((e) => e.text === currentYear)
            if (foundYear) {
                this.selectedYear = foundYear.value
            }

            this.loading = false
            this.$emit('loading', false)
        }
    }
}
</script>
